module.exports = __webpack_public_path__ + "static/media/img03.5f3647d0.webp";